import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Application  {
    _originalTypeClassName = "zvelton_Backoffice.BO.Application";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Application.translate = translateService;
}
this.Keys = [];
this.MCPs = [];
this.Id = null;
this.Name = null;
this.EnableDatabaseConnection = false;
this.EnableWebSearch = false;
this.EnableWebFetch = false;
this.EnableCodeInterpeter = false;
this.EnablezAppDevModelAccess = false;
this.zAppDev_UserEmail = null;
this.zAppDev_ApplicationId = null;
this.LLMReasoningEffort = null;
this.LLM = null;
this.RuntimeURL = null;
this.LLM_SecondarySystemPrompt = null;
this.EnableHeadlessBrowser = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
EnableDatabaseConnection:any;
EnableWebSearch:any;
EnableWebFetch:any;
EnableCodeInterpeter:any;
EnablezAppDevModelAccess:any;
zAppDev_UserEmail:any;
zAppDev_ApplicationId:any;
LLMReasoningEffort:any;
LLM:any;
RuntimeURL:any;
LLM_SecondarySystemPrompt:any;
EnableHeadlessBrowser:any;
Subscription:any;
Keys:any;
MCPs:any;
DatabaseConnectionInfo:any;
Pricelist:any;
static setSubscription = ($this, value) => {
var oldValue = $this.Subscription;
$this.Subscription = value;
if (value != null) {
if (oldValue != null) {
Domain.Subscription.removeApplications(oldValue, $this);
}
Domain.Subscription.addApplications(value, $this);
}
}
static setKeys = ($this, items) => {
                if (items == null) items = [];
                if ($this.Keys == null) $this.Keys = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Keys.length > 0) {
                    Domain.Application.removeKeys($this, $this.Keys[0]);
                }

                Domain.Application.addManyKeys($this, copyItems);
            }
static addManyKeys = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Application.addKeys($this, items[i]);
                }
            }
static addKeys = ($this, item) => {
                if ($this.Keys == null) $this.Keys = [];
                if (item == null || $this.Keys.indexOf(item) > -1) return;
                $this.Keys.push(item);
if (item.Application != $this) {
Domain.APIKey.setApplication(item, $this);
}
}
static addRangeKeys = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Application.addKeys($this, item));
            }
static removeKeys = ($this, item) => {
                if ($this == null || $this.Keys == null || $this.Keys.indexOf(item) === -1) return;
                var _index = $this.Keys.indexOf(item);
                $this.Keys.splice(_index, 1);
item.Application = null;
}
static clearKeys = ($this) => { $this.Keys = null; }
static setMCPs = ($this, items) => {
                if (items == null) items = [];
                if ($this.MCPs == null) $this.MCPs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MCPs.length > 0) {
                    Domain.Application.removeMCPs($this, $this.MCPs[0]);
                }

                Domain.Application.addManyMCPs($this, copyItems);
            }
static addManyMCPs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Application.addMCPs($this, items[i]);
                }
            }
static addMCPs = ($this, item) => {
                if ($this.MCPs == null) $this.MCPs = [];
                if (item == null || $this.MCPs.indexOf(item) > -1) return;
                $this.MCPs.push(item);
}
static addRangeMCPs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Application.addMCPs($this, item));
            }
static removeMCPs = ($this, item) => {
                if ($this == null || $this.MCPs == null || $this.MCPs.indexOf(item) === -1) return;
                var _index = $this.MCPs.indexOf(item);
                $this.MCPs.splice(_index, 1);
}
static clearMCPs = ($this) => { $this.MCPs = null; }
static setDatabaseConnectionInfo = ($this, value) => {
var oldValue = $this.DatabaseConnectionInfo;
$this.DatabaseConnectionInfo = value;
if (value != null) {
}
}
static setPricelist = ($this, value) => {
var oldValue = $this.Pricelist;
$this.Pricelist = value;
if (value != null) {
}
}

static GetPriceList($this: any): any{if ($this?.Pricelist != null) {return $this?.Pricelist;}
return $this?.Subscription?.DefaultPricelist;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}